module.exports = __webpack_public_path__ + "static/media/DatabaseIcon.b5a0c991.svg";